import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { PreferencesProvider, LessonPrefs } from 'src/app/providers/preferences/preferences.provider';

@Component({
  selector: 'app-show-hide-columns',
  templateUrl: './show-hide-columns.component.html',
  styleUrls: ['./show-hide-columns.component.scss']
})
export class ShowHideColumnsComponent implements OnInit {

  lessonPrefs: LessonPrefs

  constructor(private popoverCtrl: PopoverController,
    private preferencesProvider: PreferencesProvider) {
    this.lessonPrefs = this.preferencesProvider.getLessonPrefs()
  }

  ngOnInit() {
  }

  toggleTonality() {
    this.lessonPrefs.tonalityShown = !this.lessonPrefs.tonalityShown
  }

  toggleMeter() {
    this.lessonPrefs.meterShown = !this.lessonPrefs.meterShown
  }

  toggleSWOW() {
    this.lessonPrefs.swowShown = !this.lessonPrefs.swowShown
  }

  toggleActivity() {
    this.lessonPrefs.activityShown = !this.lessonPrefs.activityShown
  }

  toggleRP() {
    this.lessonPrefs.rpShown = !this.lessonPrefs.rpShown
  }

  toggleTP() {
    this.lessonPrefs.tpShown = !this.lessonPrefs.tpShown
  }

  toggleInstrument() {
    this.lessonPrefs.instrumentShown = !this.lessonPrefs.instrumentShown
  }

  toggleRecording() {
    this.lessonPrefs.recordingShown = !this.lessonPrefs.recordingShown
  }

  togglePEM() {
    this.lessonPrefs.pemShown = !this.lessonPrefs.pemShown
  }

  cancel() {
    this.popoverCtrl.dismiss()
  }

  save() {
    this.preferencesProvider.setLessonPrefs(this.lessonPrefs)
    this.popoverCtrl.dismiss()
  }

}
